export default __webpack_public_path__ + "static/media/WhereAreYouFrom_14.a156f649.png";